export const HeaderScroll = () => {
  
  let lastScrollTop = 0
  const triggerHeight = 220
  let offset = 0

  
  const header = document.querySelector('#header')
  const heroBgFill = header?.querySelector('.header__hero-bg-fill')
  const banner = document.querySelector('.banner') ?? null

  syncHeroBg()
  evaluateHeaderClass()

  window.addEventListener('scroll', () => {
    evaluateHeaderClass()
    syncHeroBgScroll()
  }, {passive: true})

  window.addEventListener('resize', () => {
    syncHeroBg()
  }, {passive: true})

  function getHero() {
    return document.querySelector('main .gradient')
  }

  function syncHeroBg() {
    if (!heroBgFill) return

    // Clear previous gradient classes / inline styles
    heroBgFill.className = 'header__hero-bg-fill'
    heroBgFill.style.height = ''
    heroBgFill.style.transform = ''
    heroBgFill.style.backgroundColor = ''

    const hero = getHero()

    if (hero) {
      for (const className of hero.classList) {
        if (className === 'gradient' || className.startsWith('gradient-')) {
          heroBgFill.classList.add(className)
        }
      }
      heroBgFill.style.height = `${hero.offsetHeight}px`
      syncHeroBgScroll()
      return
    }

    // No hero gradient: match first section or body background
    const firstSection = document.querySelector('main .section, main > :first-child')
    const source = firstSection ?? document.body
    let bg = getComputedStyle(source).backgroundColor
    if (!bg || bg === 'transparent' || bg === 'rgba(0, 0, 0, 0)') {
      bg = getComputedStyle(document.body).backgroundColor
    }
    heroBgFill.style.backgroundColor = bg
    heroBgFill.style.height = '100%'
  }

  function syncHeroBgScroll() {
    if (!heroBgFill) return

    const hero = getHero()
    if (!hero) return

    const st = window.pageYOffset || document.documentElement.scrollTop
    heroBgFill.style.transform = `translateY(${-st}px)`
  }

  function evaluateHeaderClass(){
    // add banner as offset
    if (banner && banner.offsetHeight) {
      offset = banner.offsetHeight
    }

    const st = window.pageYOffset || document.documentElement.scrollTop
    const scrollingUp = st < lastScrollTop
    const pastThreshold = st > (triggerHeight + offset) && st > lastScrollTop
    header.classList.toggle('header--scroll', pastThreshold)
    document.body.classList.toggle('body--scroll', pastThreshold)
    header.classList.toggle('header--detached', st > 0 && scrollingUp)
    lastScrollTop = st <= 0 ? 0 : st // For Mobile or negative scrolling
  }
}
